module.exports = __webpack_public_path__ + "static/media/58.25909331.jpg";